"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Compliance() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const features = [{
    number: "01",
    title: "EFFIZIENTE KLIMATISIERUNG",
    description: "Kühlen und heizen Sie Ihr Zuhause hocheffizient mit modernster Ducted AC System Technologie."
  }, {
    number: "02",
    title: "VOLLSTÄNDIG UNSICHTBAR",
    description: "Die Installation erfolgt diskret auf dem Dachboden – keine störenden Geräte an Ihren Wänden."
  }, {
    number: "03",
    title: "GESETZESKONFORM (EWÄRMEG)",
    description: "Erfüllen Sie spielend leicht die 15%-Erneuerbare-Energien-Regel des EWärmeG Baden-Württemberg."
  }, {
    number: "04",
    title: "FLÜSTERLEISER KOMFORT",
    description: "Genießen Sie zugfreie, perfekt temperierte Luft durch flache Deckenventile in jedem Raum."
  }];
  return <section data-section-id="4610" id="gesetzliche-vorgaben-clever-nutzen" className="dark bg-background text-foreground relative overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-screen">
        {}
        <div ref={imageRef} className={`relative h-[60vh] lg:h-auto overflow-hidden transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/ducted_ac_installation.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/ducted_ac_installation.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1714949/img/ducted_ac_installation.png-wvc-sizes" alt="Professionelle Installation einer Ducted AC System Installation auf einem Dachboden" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />
          {}
          <div className="absolute inset-0 bg-gradient-to-br from-background/40 via-transparent to-background/60" />

          {}
          <div aria-hidden="true" className="absolute left-[-20%] top-1/2 w-[140%] h-px" style={{
          transform: "rotate(30deg)",
          background: "var(--primary)",
          boxShadow: "0 0 12px var(--primary), 0 0 24px var(--primary)",
          opacity: 0.85
        }} />

          {}
          <div className="absolute bottom-8 left-8 font-mono text-xs tracking-widest" style={{
          color: "var(--muted-foreground)"
        }}>
            <span style={{
            color: "var(--primary)"
          }}>●</span> NABER AIRCONDUCT / DUCTED AC
          </div>
        </div>

        {}
        <div ref={contentRef} className={`relative flex items-start py-20 lg:py-[120px] px-6 sm:px-10 lg:pl-[80px] xl:pl-[120px] lg:pr-12 transition-all duration-1000 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="hidden lg:block absolute left-6 top-[120px] origin-top-left">
            <div className="font-mono text-[11px] tracking-[0.3em] whitespace-nowrap" style={{
            writingMode: "vertical-rl",
            transform: "rotate(180deg)",
            color: "var(--muted-foreground)"
          }}>
              DUCTED AC SYSTEM / SECTION 02
            </div>
          </div>

          <div className="w-full max-w-2xl">
            {}
            <div className="lg:hidden mb-6 font-mono text-[11px] tracking-[0.3em]" style={{
            color: "var(--muted-foreground)"
          }}>
              DUCTED AC SYSTEM / 02
            </div>

            {}
            <h2 className="font-default font-bold leading-[0.95] tracking-tighter text-5xl sm:text-6xl lg:text-7xl xl:text-[6rem] uppercase">
              <span className="block">Klima ohne</span>
              <span className="block">Sichtbare</span>
              <span className="block">
                Geräte
                <span style={{
                color: "var(--primary)",
                textShadow: "0 0 18px var(--primary)"
              }}>.</span>
              </span>
            </h2>

            {}
            <p className="font-default mt-8 text-lg sm:text-[19px] leading-relaxed max-w-[460px]" style={{
            color: "var(--muted-foreground)"
          }}>
              Das Ducted AC System für Ihr Zuhause. Wir planen und installieren hocheffiziente Systeme, 
              die nicht nur kühlen, sondern auch als vollwertige Heizung dienen und gesetzliche Vorgaben 
              wie das EWärmeG BW mühelos erfüllen.
            </p>

            {}
            <ul className="mt-14 border-t" style={{
            borderColor: "var(--border)"
          }}>
              {features.map((feature, i) => <li data-index={i} key={feature.number} className="group relative border-b py-7 grid grid-cols-[auto_1fr] gap-x-6 sm:gap-x-10 items-start cursor-default" style={{
              borderColor: "var(--border)"
            }}>
                  {}
                  <span aria-hidden="true" className="absolute left-0 top-0 bottom-0 w-[2px] opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{
                background: "var(--primary)",
                boxShadow: "0 0 10px var(--primary), 0 0 20px var(--primary)"
              }} />

                  <span className="font-mono text-xs tracking-widest pt-1" style={{
                color: "var(--muted-foreground)"
              }}>
                    {feature.number}
                  </span>

                  <div className="pl-4 sm:pl-6">
                    <h3 className="font-default font-bold text-lg sm:text-xl tracking-tight uppercase text-foreground">
                      {feature.title}
                    </h3>
                    <p className="font-default mt-2 text-base sm:text-[17px] leading-relaxed" style={{
                  color: "var(--muted-foreground)"
                }}>
                      {feature.description}
                    </p>
                  </div>
                </li>)}
            </ul>

            {}
            <div className="mt-12">
              <Button asChild size="lg" className="font-default font-bold uppercase tracking-widest text-sm h-14 px-8 shadow-2xl hover:shadow-4xl transition-shadow" style={{
              background: "var(--primary)",
              color: "var(--primary-foreground)",
              boxShadow: "0 0 24px hsla(186, 100%, 48%, 0.35), var(--shadow-2xl)"
            }}>
                <Link to="/ContactPage">
                  Beratung anfragen
                  <ArrowRight className="ml-1 h-4 w-4" />
                </Link>
              </Button>

              <div className="mt-6 font-mono text-[11px] tracking-[0.25em]" style={{
              color: "var(--muted-foreground)"
            }}>
                PLANUNG & INSTALLATION <span style={{
                color: "var(--primary)"
              }}>—</span> BUNDESWEIT
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}